import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["externalLink"]

    connect() {
        // Set initial state if needed
        this.toggleExternalLink({target: document.querySelector('#article_is_external_link')})
    }

    toggleExternalLink(event) {
        const externalLinkField = document.querySelector('#external_link_field')
        if (externalLinkField) {
            if (event.target.checked) {
                externalLinkField.classList.remove('hidden')
            } else {
                externalLinkField.classList.add('hidden')
            }
        }
    }
}
